import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/daily")({
  beforeLoad: () => {
    throw redirect({ to: "/weekly", replace: true });
  },
});
